export const ERROR_MESSAGES = "This field is required.";
export const Title = "JobMongo";
